import { isServer } from 'src/utils/index'

export enum envEnum {
  NEXT_PUBLIC_ENVIRONMENT = 'NEXT_PUBLIC_ENVIRONMENT',
  NODE_BACKEND_SERVER = 'NODE_BACKEND_SERVER',
}

export const getEnv = (env: envEnum): string => {
  const resp = isServer ? process.env[env] : window.process.env[env]

  if (resp) return resp
  throw new Error(`Empty env: ${env}`)
}
